import React, { useState } from 'react'
import { Modal, Button } from 'antd'

export const ModalComponent = () => {
  const [isModalVisible, setIsModalVisible] = useState(true)

  const handleOk = () => {
    setIsModalVisible(false)
  }
  const handleCancel = () => {
    setIsModalVisible(false)
  }
  return (
    <>
      <Modal title='Foto Archivio Ziano' visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <p>
          Una raccolta di fotografie relative ad avvenimenti accaduti dal 2001 nel Comune di Ziano Piacentino a cui si
          aggiungono sezioni tematiche . Per mantenere una memoria storica questa raccolta può essere ampliata con le tue
          vecchie immagini di avvenimenti paesaggi e cartoline che vorrai condividere. Le fotografie possono essere
          inviate ai nostri Social: <span><a
          href={'https://www.instagram.com/photostory_pc/'}>@photostory_pc</a></span>, nella mail <span><a
          href={'mailto:unico@comune.ziano.it'}>unico@comune.ziano.it</a></span> o consegnate presso gli uffici comunali (
          gli originali verranno restituiti ).
        </p>
      </Modal>
    </>
  )
}

